import { render, staticRenderFns } from "./MediumComDetail.vue?vue&type=template&id=51e18653"
import script from "./MediumComDetail.vue?vue&type=script&lang=js"
export * from "./MediumComDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports